import { client } from 'lib/evi-api-gateway';
import { IAccount } from 'types/auth';

const url = `${process.env.REACT_APP_API_URL_USER}/auth`;

export async function login(params: IAccount) {
  return client.post({
    url: `${url}/login`,
    form: {
      ...params
    }
  });
}

export async function logout(params: any) {
  return client.post({
    url: `${url}/logout`,
    form: {
      ...params
    }
  });
}

export async function verifyUrlToken(params: any) {
  return client.post({
    url: `${url}/verify_token`,
    form: {
      ...params
    }
  });
}
